"use client"

import { useState } from "react"
import PropTypes from "prop-types"
import { getSettings, setSettings } from "../../utils"
import Words from "../components/words"
import Numbers from "../components/numbers"
import Progress from "../components/progress"
import { useLanguage } from "../../../../../contexts/LanguageContext"

const CardsSettings = ({ onStart }) => {
  const { t } = useLanguage();
  const [settings, setSettingsState] = useState(getSettings("cards"))

  const changeSettings = (name, value) => {
    const newSettings = { ...setSettings(name, value).cards }
    setSettingsState(newSettings)
  }

  const getDifficultyOptions = () => [{ name: t("cardsDifficulties/0-4") }, { name: t("cardsDifficulties/0-9") }]

  return (
    <div>
      <h2>{t("selectCardsSettings")}</h2>
      <section>
        <Words
          words={getDifficultyOptions()}
          currentVal={settings.difficult}
          description={t("difficulty")}
          onChange={(val) => {
            changeSettings("cards.difficult", val)
          }}
        />
        <Numbers
          minimum={1}
          maximum={4}
          currentVal={settings.count}
          description={t("digits")}
          onChange={(val) => {
            changeSettings("cards.count", val)
          }}
        />
        <Progress
          minimum={0.1}
          maximum={5}
          step={0.1}
          currentVal={settings.speed}
          description={`${t("speed")} ${settings.speed} ${t("sec")}.`}
          onChange={(val) => {
            changeSettings("cards.speed", val)
          }}
        />
      </section>
      <footer>
        <button onClick={() => onStart()}>
          <svg fill="#FFF" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path strokeWidth={2}
              d="M 4.1565441,2.8916291 20.245369,12.180516 4.1084691,21.136604 Z"
            />
          </svg>
          <div>{t("start")}</div>
        </button>
      </footer>
    </div>
  )
}

CardsSettings.propTypes = {
  onStart: PropTypes.func.isRequired,
}

export default CardsSettings
